import { atom } from "jotai";

/**
 * Payload for opening an appointment's uploaded-document PDF viewer at a
 * specific page. `token` bumps per click so consumers can `useEffect` on
 * it and re-run their side effects even when the same link is clicked
 * twice in a row.
 */
export type AppointmentDocumentOpenRequestPayload = {
  /** Show feedback at the clicked link when the viewer cannot open it. */
  onUnavailable?: (message: string) => void;
  uploadedFileId?: string;
  filename?: string;
  page: number;
  token: number;
};

/**
 * Cross-surface event bus for appointment-document PDF viewer open
 * requests. Mirrors `amaGuideOpenRequestAtom` — the chatbot markdown
 * link handlers write here when an `indigo://appointment-doc` link is
 * clicked, and `AppointmentDetails` subscribes to open the Case
 * Documents sidebar and dispatch onto the existing `sidebarCommandAtom`
 * `PREVIEW_DOCUMENT` plumbing.
 *
 * Null between requests; set to a fresh object on each new click.
 */
export const appointmentDocumentOpenRequestAtom =
  atom<AppointmentDocumentOpenRequestPayload | null>(null);
